<template>
  <div>
    <Banner :classType="1" />
    <Menu />
    <div
      class="pageTitle wow animate__slideInUp"
      :class="{ titleEn: lang == 'en' }"
    >
      <h2>公司治理</h2>
      <p>CORPORATE GOVERNANCE</p>
    </div>

    <div class="wrap honorBox wow animate__slideInUp" v-html="content"></div>

    <div class="zllist">
      <div class="honorOrg wow animate__slideInUp">
        <ul style="text-align: center">
          <li v-for="(item, idx) in picList" :key="idx">
            <div class="wrap">
              <h2>{{ item.PicTitle }}</h2>
              <el-image :src="item.PicUrl" fit="cover"></el-image>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "@/views/components/Banner";
import Menu from "./Menu.vue";
import { WOW } from "wowjs";
import cookie from "cookiejs";

export default {
  components: {
    Banner,
    Menu,
  },
  data() {
    return {
      content: "",
      pic: "",
      lang: "zh",
      PicTitle: "",
      picList: [],
    };
  },
  methods: {
    getData() {
      this.$api
        .pageCon({
          Type: "1",
        })
        .then((res) => {
          this.content = res.Value.Content;
          this.pic = res.Value.PicUrl;
          this.PicTitle = res.Value.PicTitle;
          this.picList = res.Value.PicList;
          console.log(this.picList, "2");
          new WOW({
            boxClass: "wow",
            animateClass: "animate__animated",
            live: false,
          }).init();
        });
    },
  },
  created() {
    this.lang = cookie.get("lang");
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss">
.honorBox {
  padding: 50px 0;
  p {
    line-height: 30px;
  }
}
.honorOrg {
  
  h2 {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 40px;
  }
}
.zllist {
  li {
    padding: 45px 0;
    h2 {
      font-weight: bold;
      margin: 25px 0 0;
    }
    &:nth-child(2n + 1) {
      background: #f5f5f5;
    }
  }
}
@media (max-width: 750px) {
  .zllist {
    li {
      padding:25px 0;
      h2{
        margin:5px 0 25px;
      }
    }
  }
}
</style>
